import React from "react";
import ReactDOM from "react-dom";
import { ProfilePage } from "./components/profile-page";

const domContainer = document.getElementById("community-profile-pages");

domContainer.style.setProperty("font-family", 'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif');
domContainer.style.setProperty("max-width", "1100px", "important");
domContainer.style.setProperty("line-height", "1.5");
domContainer.style.setProperty("margin", "0 auto");

const community = JSON.parse(domContainer.dataset.community);

ReactDOM.render(<ProfilePage userProfile={community?.user_profile?.profile} />, domContainer);
